import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showError, showSuccess } from "../../helpers/toast";
import qs from "qs";
import _ from "lodash";
import { Endpoints } from "../../constants/apiEndPoints";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

API.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    // Display error message
    console.error(error.response?.data?.message || error.message);
    return Promise.reject(error);
  }
);

// Async thunk for creating a company
export const createCompany = createAsyncThunk(
  "companies/createCompany",
  async (data, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${data.accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.post("/company/", data.companyData);
      showSuccess("Create Successfully");
      return response.data;
    } catch (error) {
      showError(error.response.data.error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to create company"
      );
    }
  }
);

// Async thunk for updating a company
export const updateCompany = createAsyncThunk(
  "companies/updateCompany",
  async ({ companyId, companyData, accessToken }, { rejectWithValue }) => {
    console.log(companyId, companyData, "kkkkkkkkkkkkkkkkkkkkkkkkkkkk");
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.put(
        `/company/${companyId}`,
        companyData,
        config
      );
      showSuccess("Update Successfully");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update company"
      );
    }
  }
);

// Async thunk for deleting a company
export const deleteCompany = createAsyncThunk(
  "companies/deleteCompany",
  async ({ configdata }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${configdata.accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.delete(
        `/company/${configdata.company_id}`,
        config
      );
      return configdata.company_id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete company"
      );
    }
  }
);

// Async thunk for fetching companies
export const fetchCompanies = createAsyncThunk(
  "companies/fetchCompanies",
  async ({ accessToken, queryParams }, { rejectWithValue }) => {
    try {
      let url = "/company/";
      if (queryParams && !_.isEmpty(queryParams)) {
        url = `${url}?${queryParams instanceof Object
          ? qs.stringify(queryParams)
          : queryParams
          }`;
      }
      console.log(url, "url");
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.get(url, config);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch companies"
      );
    }
  }
);

// Async thunk for resending email
export const resendEmail = createAsyncThunk(
  "companies/resendEmail",
  async ({ authToken, company_id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${authToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.post(`/company/${company_id}/resend-email`, {}, config);
      showSuccess("Email sent successfully");
      return response.data;
    } catch (error) {
      showError(error.response?.data?.message || "Failed to resend email");
      return rejectWithValue(
        error.response?.data?.message || "Failed to resend email"
      );
    }
  }
);

// Async thunk for fetching company by id
export const fetchCompanyById = createAsyncThunk(
  "companies/fetchCompanyById",
  async (data) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
          Authorization: `${data.accessToken}`,
        },
      };
      const response = await API.get(`/company/${data.companyId}`, config);
      return response.data;
    } catch (error) {
      throw new Error("Failed to load company");
    }
  }
);

// Async thunk for fetching company applications
export const fetchCompanyApplications = createAsyncThunk(
  "companies/fetchCompanyApplications",
  async (data) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
          Authorization: `${data.accessToken}`,
        },
      };
      const response = await API.get(
        `/company/${data.companyId}/applications`,
        config
      );
      return response.data;
    } catch (error) {
      throw new Error("Failed to load company applications");
    }
  }
);

// Async thunk for reactivating a user
export const reactivateUser = createAsyncThunk(
  "companies/reactivateUser",
  async ({ email, company_id, accessToken }) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.post(
        Endpoints.reActivation,
        { email, company_id },
        config
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to reactivate user"
      );
    }
  }
);

const initialState = {
  companies: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  fetchLoading: false,
  applicationsLoading: false,
  fetchError: null,
  company: {},
  applications: [],
};

const companiesSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companies.push(action.payload);
        state.error = null;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.companies.findIndex(
          (company) => company.id === action.payload.id
        );
        if (index !== -1) {
          state.companies[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = state.companies.map((company) => {
          if (company.id === action.payload) {
            showSuccess(
              company.is_deleted ? "Restored Successfully" : "Delete Successfully"
            );
            return { ...company, is_deleted: !company.is_deleted };
          }
          return company;
        });
        state.error = null;
      })
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        // Handle both array response and paginated response
        if (Array.isArray(action.payload)) {
          state.companies = action.payload;
          // For array responses, calculate pagination based on length
          const totalPages = Math.ceil(action.payload.length / 10);
          state.pagination = {
            currentPage: 1,
            totalPages: totalPages || 1,
            totalItems: action.payload.length,
            itemsPerPage: 10,
          };
        } else {
          state.companies = action.payload.data || action.payload.companies || [];

          console.log("Pagination Debug - Payload:", action.payload); // Debug Log

          // Helper to normalize pagination data
          const getPagination = (source) => ({
            currentPage: source.current_page || source.currentPage || source.page || 1,
            totalPages: source.total_pages || source.totalPages || source.last_page || 1,
            totalItems: source.total || source.totalRecords || source.totalItems || 0,
            itemsPerPage: source.per_page || source.pageSize || source.limit || 10,
          });

          const paginationData = action.payload.pagination || action.payload.meta; // Check meta as well

          console.log("Pagination Debug - Extracted Metadata:", paginationData); // Debug Log

          if (paginationData) {
            state.pagination = getPagination(paginationData);
          } else if (action.payload.current_page || action.payload.total_pages || action.payload.last_page) {
            // Check if pagination is at the root
            state.pagination = getPagination(action.payload);
          } else {
            console.warn("Pagination Debug - No metadata found, falling back"); // Debug Log
            // Fallback pagination if no metadata provided
            const totalPages = Math.ceil(state.companies.length / 10);
            state.pagination = {
              currentPage: 1,
              totalPages: totalPages || 1,
              totalItems: state.companies.length,
              itemsPerPage: 10,
            };
          }
          console.log("Pagination Debug - Final State:", state.pagination); // Debug Log
        }
        state.error = null;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resendEmail.pending, (state) => {
        state.loading = true;
      })
      .addCase(resendEmail.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(resendEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCompanyById.pending, (state) => {
        state.fetchLoading = true;
      })
      .addCase(fetchCompanyById.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.company = action.payload;
        state.fetchError = null;
      })
      .addCase(fetchCompanyById.rejected, (state, action) => {
        state.fetchLoading = false;
        state.fetchError = action.error?.message;
        state.company = initialState.company;
        state.error = null;
      })
      .addCase(fetchCompanyApplications.pending, (state) => {
        state.applicationsLoading = true;
      })
      .addCase(fetchCompanyApplications.fulfilled, (state, action) => {
        state.applicationsLoading = false;
        // Handle both array response and nested structures safely
        const payload = action.payload;
        if (Array.isArray(payload)) {
          state.applications = payload;
        } else if (Array.isArray(payload?.applications)) {
          state.applications = payload.applications;
        } else if (Array.isArray(payload?.data)) {
          state.applications = payload.data;
        } else {
          state.applications = [];
        }
        state.fetchError = null;
      })
      .addCase(fetchCompanyApplications.rejected, (state, action) => {
        state.applicationsLoading = false;
        state.fetchError = action.error?.message;
        state.applications = initialState.applications;
        state.error = null;
      });
  },
});

export default companiesSlice.reducer;
